<template>
  <div class="max-w-xlg m-auto px-4 w-full">
    <slot />
  </div>
</template>
